module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donut-chart-loader"
  }, [_c('svg', {
    staticClass: "loader",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "preserveAspectRatio": "xMidYMid meet",
      "viewBox": "0 0 150 200",
      "width": "200"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M146.46 73.81C146.46 113.54 114.2 145.8 74.47 145.8C34.74 145.8 2.49 113.54 2.49 73.81C2.49 34.08 34.74 1.83 74.47 1.83C114.2 1.83 146.46 34.08 146.46 73.81Z",
      "id": "a187zY3obG"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113.84 71.76C113.84 93.48 96.2 111.12 74.47 111.12C52.75 111.12 35.11 93.48 35.11 71.76C35.11 50.03 52.75 32.4 74.47 32.4C96.2 32.4 113.84 50.03 113.84 71.76Z",
      "id": "cBWDMaKOE"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "",
      "id": "i1HnPNnU2L"
    }
  })]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a187zY3obG",
      "opacity": "1",
      "fill": "#ececec",
      "fill-opacity": "1"
    }
  })]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#cBWDMaKOE",
      "opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('use', {
    attrs: {
      "xlink:href": "#i1HnPNnU2L",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e9e9e9",
      "stroke-width": "1",
      "stroke-opacity": "1"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61e2fb2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/content-loaders/DoughnutChartLoader.vue
// module id = 3305
// module chunks = 3